import { Component, inject, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { KENDO_FORMFIELD, KENDO_TEXTAREA } from '@progress/kendo-angular-inputs';
import { KENDO_LABEL } from '@progress/kendo-angular-label';
import { ErrorWrapperComponent } from '@unity/forms/composed/error-wrapper/error-wrapper.component';
import { LayoutService } from '@unity/services/layout.service';

@Component({
  selector: 'unity-control-wrapper',
  imports: [KENDO_FORMFIELD, KENDO_TEXTAREA, KENDO_LABEL, ReactiveFormsModule, ErrorWrapperComponent],
  templateUrl: './control-wrapper.component.html',
  styleUrl: './control-wrapper.component.scss',
})
export class ControlWrapperComponent<T> {
  readonly #layoutService = inject(LayoutService);

  protected readonly $orientation = this.#layoutService.$orientation;

  public readonly $control = input.required<FormControl<T>>({ alias: 'control' });
  public readonly $displayName = input.required<string>({ alias: 'displayName' });
  public readonly $description = input.required<string>({ alias: 'description' });
  public readonly $showHint = input.required({ alias: 'showHint' });
}
